import { OrderedMap, List } from 'immutable'
import { compose, withHandlers, withProps } from 'recompose'
import { Gates } from 'utils/Access'

import SelectContainer from '../../../components/playbook/components/TargetingDisplay/SelectContainer'
import SelectsContainer from '../../../components/playbook/components/TargetingDisplay/SelectsContainer'
import RepSelectContainer from '../../../components/playbook/components/TargetingDisplay/RepSelectContainer'
import { NumberInput, StringsInput } from '../../../components/playbook/components/TargetingDisplay/Inputs'

import withOrgTeams from 'app/modules/teams/hoc/withOrgTeams'

import ClearbitTags from 'constants/ClearbitTags'
import ClearbitTechOptions from 'constants/ClearbitTech'
import ClearbitRevenueRanges from 'constants/ClearbitRevenueRanges'
import { UspsCodesToStateName } from 'constants/UspsStates'
import { IsoToCountriesNames } from 'constants/ISOCountries'
import { makeConstantFactory } from 'utils/constantsHelper'
import { DemandbaseAudiences } from 'constants/DemandbaseAudiences'
import DemandbaseEmployeeRanges from 'constants/DemandbaseEmployeeRanges'
import DemandbaseRevenueRanges from 'constants/DemandbaseRevenueRanges'

import knownUsersSrc from '!svg-inline?removeTags=true!images/svg/known_users.svg'
import siteVisitorsSrc from '!svg-inline?removeTags=true!images/svg/site_visitors.svg'

const makeConstant = makeConstantFactory('playbook')

export const FETCH_PLAYBOOK = makeConstant('FETCH_PLAYBOOK')
export const FETCH_PLAYBOOK_PENDING = makeConstant('FETCH_PLAYBOOK_PENDING')
export const FETCH_PLAYBOOK_CANCELLED = makeConstant('FETCH_PLAYBOOK_CANCELLED')
export const FETCH_PLAYBOOK_FAILED = makeConstant('FETCH_PLAYBOOK_FAILED')

export const GET_PLAYBOOK = makeConstant('GET_PLAYBOOK')
export const GET_PLAYBOOK_PENDING = makeConstant('GET_PLAYBOOK_PENDING')
export const GET_PLAYBOOK_CANCELLED = makeConstant('GET_PLAYBOOK_CANCELLED')
export const GET_PLAYBOOK_FAILED = makeConstant('GET_PLAYBOOK_FAILED')
export const GET_PLAYBOOK_SUCCESS = makeConstant('GET_PLAYBOOK_SUCCESS')

export const GET_PLAYBOOK_BY_CAMPAIGN_ID = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID')
export const GET_PLAYBOOK_BY_CAMPAIGN_ID_PENDING = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID_PENDING')
export const GET_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED')
export const GET_PLAYBOOK_BY_CAMPAIGN_ID_FAILED = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID_FAILED')
export const GET_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS = makeConstant('GET_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS')

export const FETCH_PLAYBOOK_COUNTS = makeConstant('FETCH_PLAYBOOK_COUNTS')
export const FETCH_PLAYBOOK_COUNTS_PENDING = makeConstant('FETCH_PLAYBOOK_COUNTS_PENDING')
export const FETCH_PLAYBOOK_COUNTS_CANCELLED = makeConstant('FETCH_PLAYBOOK_COUNTS_CANCELLED')
export const FETCH_PLAYBOOK_COUNTS_SUCCESS = makeConstant('FETCH_PLAYBOOK_COUNTS_SUCCESS')
export const FETCH_PLAYBOOK_COUNTS_FAILED = makeConstant('FETCH_PLAYBOOK_COUNTS_FAILED')

export const FETCH_PLAYBOOK_CARDINALITY = makeConstant('FETCH_PLAYBOOK_CARDINALITY')
export const FETCH_PLAYBOOK_CARDINALITY_PENDING = makeConstant('FETCH_PLAYBOOK_CARDINALITY_PENDING')
export const FETCH_PLAYBOOK_CARDINALITY_SUCCESS = makeConstant('FETCH_PLAYBOOK_CARDINALITY_SUCCESS')
export const FETCH_PLAYBOOK_CARDINALITY_FAILED = makeConstant('FETCH_PLAYBOOK_CARDINALITY_FAILED')
export const FETCH_PLAYBOOK_CARDINALITY_CANCELLED = makeConstant('FETCH_PLAYBOOK_CARDINALITY_CANCELLED')

export const FETCH_PLAYBOOK_BY_CAMPAIGN_ID = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID')
export const FETCH_PLAYBOOK_BY_CAMPAIGN_ID_PENDING = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID_PENDING')
export const FETCH_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID_CANCELLED')
export const FETCH_PLAYBOOK_BY_CAMPAIGN_ID_FAILED = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID_FAILED')
export const FETCH_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS = makeConstant('FETCH_PLAYBOOK_BY_CAMPAIGN_ID_SUCCESS')

export const FETCH_PLAYBOOKS_BY_REPORT_TYPE = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE')
export const FETCH_PLAYBOOKS_BY_REPORT_TYPE_PENDING = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE_PENDING')
export const FETCH_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED')
export const FETCH_PLAYBOOKS_BY_REPORT_TYPE_FAILED = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE_FAILED')
export const FETCH_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS = makeConstant('FETCH_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS')

export const FETCH_PLAYBOOK_BY_INTERACTION_ID = makeConstant('FETCH_PLAYBOOK_BY_INTERACTION_ID')
export const FETCH_PLAYBOOK_BY_INTERACTION_ID_PENDING = makeConstant(
  'FETCH_PLAYBOOK_BY_INTERACTION_ID_PENDING'
)
export const FETCH_PLAYBOOK_BY_INTERACTION_ID_CANCELLED = makeConstant(
  'FETCH_PLAYBOOK_BY_INTERACTION_ID_CANCELLED'
)
export const FETCH_PLAYBOOK_BY_INTERACTION_ID_FAILED = makeConstant('FETCH_PLAYBOOK_BY_INTERACTION_ID_FAILED')
export const FETCH_PLAYBOOK_BY_INTERACTION_ID_SUCCESS = makeConstant(
  'FETCH_PLAYBOOK_BY_INTERACTION_ID_SUCCESS'
)

export const ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE')
export const ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_FAILED = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_FAILED')
export const ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_PENDING = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_PENDING')
export const ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_CANCELLED')
export const ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS = makeConstant('ENABLE_ALL_PLAYBOOKS_BY_REPORT_TYPE_SUCCESS')

export const CREATE_PLAYBOOK = makeConstant('CREATE_PLAYBOOK')
export const CREATE_PLAYBOOK_PENDING = makeConstant('CREATE_PLAYBOOK_PENDING')
export const CREATE_PLAYBOOK_CANCELLED = makeConstant('CREATE_PLAYBOOK_CANCELLED')
export const CREATE_PLAYBOOK_FAILED = makeConstant('CREATE_PLAYBOOK_FAILED')

export const CLONE_PLAYBOOK = makeConstant('CLONE_PLAYBOOK')
export const CLONE_PLAYBOOK_PENDING = makeConstant('CLONE_PLAYBOOK_PENDING')
export const CLONE_PLAYBOOK_CANCELLED = makeConstant('CLONE_PLAYBOOK_CANCELLED')
export const CLONE_PLAYBOOK_FAILED = makeConstant('CLONE_PLAYBOOK_FAILED')
export const CLONE_PLAYBOOK_SUCCESS = makeConstant('CLONE_PLAYBOOK_SUCCESS')

export const ARCHIVE_PLAYBOOK = makeConstant('ARCHIVE_PLAYBOOK')
export const ARCHIVE_PLAYBOOK_PENDING = makeConstant('ARCHIVE_PLAYBOOK_PENDING')
export const ARCHIVE_PLAYBOOK_CANCELLED = makeConstant('ARCHIVE_PLAYBOOK_CANCELLED')
export const ARCHIVE_PLAYBOOK_FAILED = makeConstant('ARCHIVE_PLAYBOOK_FAILED')
export const ARCHIVE_PLAYBOOK_SUCCESS = makeConstant('ARCHIVE_PLAYBOOK_SUCCESS')

export const SEND_TEST_EMAIL = makeConstant('SEND_TEST_EMAIL')
export const SEND_TEST_EMAIL_SUCCESS = makeConstant('SEND_TEST_EMAIL_SUCCESS')
export const SEND_TEST_EMAIL_PENDING = makeConstant('SEND_TEST_EMAIL_PENDING')
export const SEND_TEST_EMAIL_FAILED = makeConstant('SEND_TEST_EMAIL_FAILED')

export const SEND_TEST_SEQUENCE = makeConstant('SEND_TEST_SEQUENCE')
export const SEND_TEST_SEQUENCE_PENDING = makeConstant('SEND_TEST_SEQUENCE_PENDING')
export const SEND_TEST_SEQUENCE_FAILED = makeConstant('SEND_TEST_SEQUENCE_FAILED')
export const SEND_TEST_SEQUENCE_SUCCESS = makeConstant('SEND_TEST_SEQUENCE_SUCCESS')
export const SEND_TEST_SEQUENCE_CANCELLED = makeConstant('SEND_TEST_SEQUENCE_CANCELLED')

export const SEARCH_ENABLED_PLAYBOOKS = makeConstant('SEARCH_ENABLED_PLAYBOOKS')
export const SEARCH_PLAYBOOKS = makeConstant('SEARCH_PLAYBOOKS')
export const SEARCH_PLAYBOOKS_PENDING = makeConstant('SEARCH_PLAYBOOKS_PENDING')
export const SEARCH_PLAYBOOKS_CANCELLED = makeConstant('SEARCH_PLAYBOOKS_CANCELLED')
export const SEARCH_PLAYBOOKS_FAILED = makeConstant('SEARCH_PLAYBOOKS_FAILED')
export const SEARCH_PLAYBOOKS_SUCCESS = makeConstant('SEARCH_PLAYBOOKS_SUCCESS')

export const SAVE_PLAYBOOK = makeConstant('SAVE_PLAYBOOK')
export const SAVE_PLAYBOOK_PENDING = makeConstant('SAVE_PLAYBOOK_PENDING')
export const SAVE_PLAYBOOK_CANCELLED = makeConstant('SAVE_PLAYBOOK_CANCELLED')
export const SAVE_PLAYBOOK_SUCCESS = makeConstant('SAVE_PLAYBOOK_SUCCESS')
export const SAVE_PLAYBOOK_FAILED = makeConstant('SAVE_PLAYBOOK_FAILED')

export const SET_STATUS = makeConstant('SET_STATUS')

export const SAVE_PLAYBOOK_DRAFT = makeConstant('SAVE_PLAYBOOK_DRAFT')
export const SAVE_PLAYBOOK_DRAFT_PENDING = makeConstant('SAVE_PLAYBOOK_DRAFT_PENDING')
export const SAVE_PLAYBOOK_DRAFT_CANCELLED = makeConstant('SAVE_PLAYBOOK_DRAFT_CANCELLED')
export const SAVE_PLAYBOOK_DRAFT_FAILED = makeConstant('SAVE_PLAYBOOK_DRAFT_FAILED')

export const SCHEDULE_PLAYBOOK_DRAFT = makeConstant('SCHEDULE_PLAYBOOK_DRAFT')

export const RECEIVE_PLAYBOOK_DRAFT = makeConstant('RECEIVE_PLAYBOOK_DRAFT')
export const ACCEPT_PLAYBOOK_DRAFT = makeConstant('ACCEPT_PLAYBOOK_DRAFT')
export const CLEAR_DRAFT = makeConstant('CLEAR_DRAFT')

export const DISABLE_PLAYBOOK_AUTOSAVE = makeConstant('DISABLE_PLAYBOOK_AUTOSAVE')
export const ENABLE_PLAYBOOK_AUTOSAVE = makeConstant('ENABLE_PLAYBOOK_AUTOSAVE')
export const MARK_DRAFT_UNSAVED = makeConstant('MARK_DRAFT_UNSAVED')

export const SET_DRAFT_STATUS = makeConstant('SET_DRAFT_STATUS')
export const SET_DRAFT_STATUS_PENDING = makeConstant('SET_DRAFT_STATUS_PENDING')
export const SET_DRAFT_STATUS_CANCELLED = makeConstant('SET_DRAFT_STATUS_CANCELLED')
export const SET_DRAFT_STATUS_SUCCESS = makeConstant('SET_DRAFT_STATUS_SUCCESS')
export const SET_DRAFT_STATUS_DRAFT_FAILED = makeConstant('SET_DRAFT_STATUS_DRAFT_FAILED')

export const SET_NAME = makeConstant('SET_NAME')
export const SET_SLUG = makeConstant('SET_SLUG')

export const FETCH_DATA_PREVIEW_EMAIL = makeConstant('FETCH_DATA_PREVIEW_EMAIL')
export const FETCH_DATA_PREVIEW_EMAIL_PENDING = makeConstant('FETCH_DATA_PREVIEW_EMAIL_PENDING')
export const FETCH_DATA_PREVIEW_EMAIL_CANCELLED = makeConstant('FETCH_DATA_PREVIEW_EMAIL_CONCELLED')
export const FETCH_DATA_PREVIEW_EMAIL_FAILED = makeConstant('FETCH_DATA_PREVIEW_EMAIL_FAILED')
export const FETCH_DATA_PREVIEW_EMAIL_SUCCESS = makeConstant('FETCH_DATA_PREVIEW_EMAIL_SUCCESS')

export const FETCH_DATA_PREVIEW_SEQUENCE_EMAIL = makeConstant('FETCH_DATA_PREVIEW_SEQUENCE_EMAIL')
export const FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_PENDING = makeConstant(
  'FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_PENDING'
)
export const FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_CANCELLED = makeConstant(
  'FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_CONCELLED'
)
export const FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_FAILED = makeConstant(
  'FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_FAILED'
)
export const FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_SUCCESS = makeConstant(
  'FETCH_DATA_PREVIEW_SEQUENCE_EMAIL_SUCCESS'
)

export const SET_SEQUENCE_DYNAMIC_SENDER_FORMAT = makeConstant('SET_SEQUENCE_DYNAMIC_SENDER_FORMAT')
export const SET_SEQUENCE_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE = makeConstant(
  'SET_SEQUENCE_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE'
)
export const SET_SEQUENCE_EMAIL_OVERRIDE = makeConstant('SET_SEQUENCE_EMAIL_OVERRIDE')
export const SET_SEQUENCE_SENDER_NAME = makeConstant('SET_SEQUENCE_SENDER_NAME')
export const SET_SEQUENCE_INDIVIDUAL_EMAIL_OVERRIDE = makeConstant('SET_SEQUENCE_INDIVIDUAL_EMAIL_OVERRIDE')
export const SET_SEQUENCE_INDIVIDUAL_SENDER_NAME = makeConstant('SET_SEQUENCE_INDIVIDUAL_SENDER_NAME')
export const SET_SEQUENCE_INDIVIDUAL_DYNAMIC_ATTR = makeConstant('SET_SEQUENCE_INDIVIDUAL_DYNAMIC_ATTR')
export const SET_SEQUENCE_INDIVIDUAL_DYNAMIC_FORMAT = makeConstant('SET_SEQUENCE_INDIVIDUAL_DYNAMIC_FORMAT')
export const SET_DYNAMIC_SENDER_FORMAT = makeConstant('SET_DYNAMIC_SENDER_FORMAT')
export const SET_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE = makeConstant('SET_DYNAMIC_ACCOUNT_SEND_ATTRIBUTE')
export const SET_EMAIL_OVERRIDE = makeConstant('SET_EMAIL_OVERRIDE')
export const SET_SENDER_NAME = makeConstant('SET_SENDER_NAME')
export const SET_MESSAGE = makeConstant('SET_MESSAGE')
export const SET_VIDEO_URL = makeConstant('VIDEO_URL')
export const SET_HEADLINE = makeConstant('SET_HEADLINE')
export const SET_THANK_YOU_MESSAGE = makeConstant('SET_THANK_YOU_MESSAGE')
export const SET_THANK_YOU_HEADLINE = makeConstant('SET_THANK_YOU_HEADLINE')
export const SET_CTA_TYPE = makeConstant('SET_CTA_TYPE')
export const SET_CTA_LINK = makeConstant('SET_CTA_LINK')
export const SET_CTA_COPY = makeConstant('SET_CTA_COPY')
export const SET_SEQUENCE_AUTHOR_ID = makeConstant('SET_SEQUENCE_AUTHOR_ID')
export const SET_AUTHOR_ID = makeConstant('SET_AUTHOR_ID')
export const SET_EMAIL_THEME = makeConstant('SET_EMAIL_THEME')

export const SET_EMAIL_TITLE = makeConstant('SET_EMAIL_TITLE')
export const SET_EMAIL_MESSAGE = makeConstant('SET_EMAIL_MESSAGE')
export const SET_EMAIL_DELAY = makeConstant('SET_EMAIL_DELAY')
export const ADD_EMAIL = makeConstant('ADD_EMAIL')
export const DELETE_EMAIL = makeConstant('DELETE_EMAIL')
export const MOVE_EMAIL_UP = makeConstant('MOVE_EMAIL_UP')
export const SET_WEEKDAYS_ONLY = makeConstant('SET_WEEKDAYS_ONLY')
export const SET_SMART_SENDING = makeConstant('SET_SMART_SENDING')
export const SET_UNENROLL_ON_REPLY = makeConstant('SET_UNENROLL_ON_REPLY')
export const SET_UNENROLL_ON_REPLY_BY_DOMAIN = makeConstant('SET_UNENROLL_ON_REPLY_BY_DOMAIN')
export const SET_THREADED_WITH_PREVIOUS = makeConstant('SET_THREADED_WITH_PREVIOUS')

export const SET_GREETING = makeConstant('SET_GREETING')
export const SET_QUESTION_PROMPT = makeConstant('SET_QUESTION_PROMPT')
export const ADD_QUESTION = makeConstant('ADD_QUESTION')
export const ADD_EMAIL_CAPTURE_QUESTION = makeConstant('ADD_EMAIL_CAPTURE_QUESTION')
export const ADD_PHONE_CAPTURE_QUESTION = makeConstant('ADD_PHONE_CAPTURE_QUESTION')
export const DELETE_QUESTION = makeConstant('DELETE_QUESTION')
export const MOVE_QUESTION_UP = makeConstant('MOVE_QUESTION_UP')
export const ADD_ANSWER = makeConstant('ADD_ANSWER')
export const DELETE_ANSWER = makeConstant('DELETE_ANSWER')
export const FLAG_ANSWER = makeConstant('FLAG_ANSWER')
export const SET_SKIP_TO = makeConstant('SET_SKIP_TO')
export const SET_FIELD_ATTRIBUTE_NAME = makeConstant('SET_FIELD_ATTRIBUTE_NAME')
export const SET_BUTTON_ONLY_RESPONSES = makeConstant('SET_BUTTON_ONLY_RESPONSES')
export const ADD_GOAL = makeConstant('ADD_GOAL')
export const DELETE_GOAL = makeConstant('DELETE_GOAL')
export const SET_GOAL_CLASSIFICATION = makeConstant('SET_GOAL_CLASSIFICATION')
export const SET_CURRENT_GOAL_ID = makeConstant('SET_CURRENT_GOAL_ID')
export const SET_GOAL_MESSAGE = makeConstant('SET_GOAL_MESSAGE')
export const DELETE_KEYWORD = makeConstant('DELETE_KEYWORD')
export const ADD_KEYWORD = makeConstant('ADD_KEYWORD')
export const SET_KEYWORD_TEXT = makeConstant('SET_KEYWORD_TEXT')
export const SET_KEYWORD_TYPE = makeConstant('SET_KEYWORD_TYPE')
export const SET_ANSWER_TYPE = makeConstant('SET_ANSWER_TYPE')
export const SET_BUTTON_TEXT = makeConstant('SET_BUTTON_TEXT')
export const SET_RESPONSE = makeConstant('SET_RESPONSE')
export const SET_DEFAULT_PHONE_COUNTRY_CODE = makeConstant('SET_DEFAULT_PHONE_COUNTRY_CODE')

export const SET_ACTION_INBOX_ID = makeConstant('SET_ACTION_INBOX_ID')

export const SET_GOAL_ROUTING_OPTION = makeConstant('SET_GOAL_ROUTING_OPTION')
export const SAVE_GOAL_ROUTING_OPTION = makeConstant('SAVE_GOAL_ROUTING_OPTION')
export const SET_GOAL_ROUTING_VIEW = makeConstant('SET_GOAL_ROUTING_VIEW')
export const SELECT_GOAL_ACTION = makeConstant('SELECT_GOAL_ACTION')
export const SAVE_GOAL_ACTION = makeConstant('SAVE_GOAL_ACTION')
export const REMOVE_GOAL_ACTION = makeConstant('REMOVE_GOAL_ACTION')

export const SHOW_SEND_EMAIL_CONFIRM_MODAL = makeConstant('SHOW_SEND_EMAIL_CONFIRM_MODAL')
export const HIDE_SEND_EMAIL_CONFIRM_MODAL = makeConstant('HIDE_SEND_EMAIL_CONFIRM_MODAL')
export const SHOW_EDIT_SENDER_MODAL = makeConstant('SHOW_EDIT_SENDER_MODAL')
export const HIDE_EDIT_SENDER_MODAL = makeConstant('HIDE_EDIT_SENDER_MODAL')
export const SHOW_CALENDAR_LINK_MODAL = makeConstant('SHOW_CALENDAR_LINK_MODAL')
export const HIDE_CALENDAR_LINK_MODAL = makeConstant('HIDE_CALENDAR_LINK_MODAL')
export const SHOW_TOKEN_MODAL = makeConstant('SHOW_TOKEN_MODAL')
export const HIDE_TOKEN_MODAL = makeConstant('HIDE_TOKEN_MODAL')
export const SHOW_CTA_BUTTON_MODAL = makeConstant('SHOW_CTA_BUTTON_MODAL')
export const HIDE_CTA_BUTTON_MODAL = makeConstant('HIDE_CTA_BUTTON_MODAL')
export const SHOW_EXTENSION_INVITE_MODAL = makeConstant('SHOW_EXTENSION_INVITE_MODAL')
export const HIDE_EXTENSION_INVITE_MODAL = makeConstant('HIDE_EXTENSION_INVITE_MODAL')
export const SHOW_GOAL_ACTION_MODAL = makeConstant('SHOW_GOAL_ACTION_MODAL')
export const HIDE_GOAL_ACTION_MODAL = makeConstant('HIDE_GOAL_ACTION_MODAL')
export const SHOW_GOAL_ROUTING_MODAL = makeConstant('SHOW_GOAL_ROUTING_MODAL')
export const HIDE_GOAL_ROUTING_MODAL = makeConstant('HIDE_GOAL_ROUTING_MODAL')
export const SHOW_ANSWER_MODAL = makeConstant('SHOW_ANSWER_MODAL')
export const HIDE_ANSWER_MODAL = makeConstant('HIDE_ANSWER_MODAL')
export const SHOW_QUESTION_ADVANCED_MODAL = makeConstant('SHOW_QUESTION_ADVANCED_MODAL')
export const HIDE_QUESTION_ADVANCED_MODAL = makeConstant('HIDE_QUESTION_ADVANCED_MODAL')
export const SHOW_CONDITION_MODAL = makeConstant('SHOW_CONDITION_MODAL')
export const HIDE_CONDITION_MODAL = makeConstant('HIDE_CONDITION_MODAL')
export const SHOW_SCHEDULE_MODAL = makeConstant('SHOW_SCHEDULE_MODAL')
export const HIDE_SCHEDULE_MODAL = makeConstant('HIDE_SCHEDULE_MODAL')
export const SHOW_SEQUENCE_INVITE_MODAL = makeConstant('SHOW_SEQUENCE_INVITE_MODAL')
export const HIDE_SEQUENCE_INVITE_MODAL = makeConstant('HIDE_SEQUENCE_INVITE_MODAL')
export const SHOW_GOOGLE_AUTH_MODAL = makeConstant('SHOW_GOOGLE_AUTH_MODAL')
export const HIDE_GOOGLE_AUTH_MODAL = makeConstant('HIDE_GOOGLE_AUTH_MODAL')
export const SHOW_DISABLE_SALES_SEQUENCE_MODAL = makeConstant('SHOW_DISABLE_SALES_SEQUENCE_MODAL')
export const HIDE_DISABLE_SALES_SEQUENCE_MODAL = makeConstant('HIDE_DISABLE_SALES_SEQUENCE_MODAL')

export const RESET_DISPLAY_CONDITIONS = makeConstant('RESET_DISPLAY_CONDITIONS')
export const SET_TARGETING_DISPLAY_VIEW = makeConstant('SET_TARGETING_DISPLAY_VIEW')
export const SET_TARGETING_DISPLAY_TARGET_ID = makeConstant('SET_TARGETING_DISPLAY_TARGET_ID')
export const SET_EMAIL_PLAYBOOK_CONDITION_VALUE = makeConstant('SET_EMAIL_PLAYBOOK_CONDITION_VALUE')
export const SET_CONDITION_VALUE = makeConstant('SET_CONDITION_VALUE')
export const SET_CONDITION_FIELD = makeConstant('SET_CONDITION_FIELD')
export const SET_CONDITION_OPERATOR = makeConstant('SET_CONDITION_OPERATOR')
export const DELETE_CONDITION = makeConstant('DELETE_CONDITION')
export const ADD_CONDITION = makeConstant('ADD_CONDITION')
export const DELETE_CONDITION_SET = makeConstant('DELETE_CONDITION_SET')
export const ADD_CONDITION_SET = makeConstant('ADD_CONDITION_SET')

export const SET_AUDIENCE = makeConstant('SET_AUDIENCE')
export const SET_DRAFT_SCHEDULE = makeConstant('SET_DRAFT_SCHEDULE')
export const SET_EXCLUDED_USER_LIST_IDS = makeConstant('SET_EXCLUDED_USER_LIST_IDS')
export const SET_USER_LIST_IDS = makeConstant('SET_USER_LIST_IDS')
export const SET_EXCLUDED_ACCOUNT_LIST_IDS = makeConstant('SET_EXCLUDED_ACCOUNT_LIST_IDS')
export const SET_ACCOUNT_LIST_IDS = makeConstant('SET_ACCOUNT_LIST_IDS')
export const SET_SMART_FILTERS_CUSTOMERS = makeConstant('SET_SMART_FILTERS_CUSTOMERS')
export const SET_SMART_FILTERS_ENGAGED_CONTACTS = makeConstant('SET_SMART_FILTERS_ENGAGED_CONTACTS')
export const SET_SMART_FILTERS_CHAT_ENGAGED_CONTACTS = makeConstant('SET_SMART_FILTERS_CHAT_ENGAGED_CONTACTS')
export const SET_SMART_FILTERS = makeConstant('SET_SMART_FILTERS')

export const FETCH_PLAYBOOKS_PRIORITY = makeConstant('FETCH_PLAYBOOKS_PRIORITY')
export const FETCH_PLAYBOOKS_PRIORITY_PENDING = makeConstant('FETCH_PLAYBOOKS_PRIORITY_PENDING')
export const FETCH_PLAYBOOKS_PRIORITY_CANCELLED = makeConstant('FETCH_PLAYBOOKS_PRIORITY_CANCELLED')
export const FETCH_PLAYBOOKS_PRIORITY_FAILED = makeConstant('FETCH_PLAYBOOKS_PRIORITY_FAILED')
export const FETCH_PLAYBOOKS_PRIORITY_SUCCESS = makeConstant('FETCH_PLAYBOOKS_PRIORITY_SUCCESS')

export const SET_META_ATTRIBUTE = makeConstant('SET_META_ATTRIBUTE')

export const HIDE_SEGMENT_SELECT = makeConstant('HIDE_SEGMENT_SELECT')
export const SHOW_SEGMENT_SELECT = makeConstant('SHOW_SEGMENT_SELECT')

export const SET_DRAFT_FREQUENCY = makeConstant('SET_DRAFT_FREQUENCY')
export const DISABLE_PLAYBOOK = makeConstant('DISABLE_PLAYBOOK')
export const ALL_CHANGES = makeConstant('ALL_CHANGES')

export const ENROLL = makeConstant('ENROLL')
export const ENROLL_PENDING = makeConstant('ENROLL_PENDING')
export const ENROLL_FAILED = makeConstant('ENROLL_FAILED')
export const ENROLL_SUCCESS = makeConstant('ENROLL_SUCCESS')

export const UNENROLL = makeConstant('UNENROLL')
export const UNENROLL_PENDING = makeConstant('UNENROLL_PENDING')
export const UNENROLL_FAILED = makeConstant('UNENROLL_FAILED')
export const UNENROLL_SUCCESS = makeConstant('UNENROLL_SUCCESS')

export const NOTIFY = makeConstant('NOTIFY')
export const NOTIFY_PENDING = makeConstant('NOTIFY_PENDING')
export const NOTIFY_FAILED = makeConstant('NOTIFY_FAILED')
export const NOTIFY_SUCCESS = makeConstant('NOTIFY_SUCCESS')

export const FETCH_PLAYBOOKS_BY_IDS = makeConstant('FETCH_PLAYBOOKS_BY_IDS')
export const FETCH_PLAYBOOKS_BY_IDS_SUCCESS = makeConstant('FETCH_PLAYBOOKS_BY_IDS_SUCCESS')
export const FETCH_PLAYBOOKS_BY_IDS_PENDING = makeConstant('FETCH_PLAYBOOKS_BY_IDS_PENDING')
export const FETCH_PLAYBOOKS_BY_IDS_FAILED = makeConstant('FETCH_PLAYBOOKS_BY_IDS_FAILED')

export const FETCH_ENROLLED_PLAYBOOK_ID = makeConstant('FETCH_ENROLLED_PLAYBOOK_ID')
export const FETCH_ENROLLED_PLAYBOOK_ID_SUCCESS = makeConstant('FETCH_ENROLLED_PLAYBOOK_ID_SUCCESS')
export const FETCH_ENROLLED_PLAYBOOK_ID_PENDING = makeConstant('FETCH_ENROLLED_PLAYBOOK_ID_PENDING')
export const FETCH_ENROLLED_PLAYBOOK_ID_FAILED = makeConstant('FETCH_ENROLLED_PLAYBOOK_ID_FAILED')

export const FETCH_ENROLLED_SEQUENCE_COUNT = makeConstant('FETCH_ENROLLED_SEQUENCE_COUNT')
export const FETCH_ENROLLED_SEQUENCE_COUNT_SUCCESS = makeConstant('FETCH_ENROLLED_SEQUENCE_COUNT_SUCCESS')
export const FETCH_ENROLLED_SEQUENCE_COUNT_PENDING = makeConstant('FETCH_ENROLLED_SEQUENCE_COUNT_PENDING')
export const FETCH_ENROLLED_SEQUENCE_COUNT_FAILED = makeConstant('FETCH_ENROLLED_SEQUENCE_COUNT_FAILED')

export const FETCH_PLAYBOOK_FOR_END_USER = makeConstant('FETCH_PLAYBOOK_FOR_END_USER')
export const FETCH_PLAYBOOK_FOR_END_USER_SUCCESS = makeConstant('FETCH_PLAYBOOK_FOR_END_USER_SUCCESS')
export const FETCH_PLAYBOOK_FOR_END_USER_PENDING = makeConstant('FETCH_PLAYBOOK_FOR_END_USER_PENDING')
export const FETCH_PLAYBOOK_FOR_END_USER_FAILED = makeConstant('FETCH_PLAYBOOK_FOR_END_USER_FAILED')

export const SET_PLAYBOOK_FOR_END_USER_SUBJECT = makeConstant('SET_PLAYBOOK_FOR_END_USER_SUBJECT')
export const SET_PLAYBOOK_FOR_END_USER_MESSAGE = makeConstant('SET_PLAYBOOK_FOR_END_USER_MESSAGE')
export const SET_PLAYBOOK_FOR_END_USER_DELAY = makeConstant('SET_PLAYBOOK_FOR_END_USER_DELAY')

export const CLEAR_EMAIL_BANNER = makeConstant('CLEAR_EMAIL_BANNER')
export const SET_EMAIL_BANNER = makeConstant('SET_EMAIL_BANNER')
export const SET_EMAIL_BANNER_PENDING = makeConstant('SET_EMAIL_BANNER_PENDING')
export const SET_EMAIL_BANNER_SUCCESS = makeConstant('SET_EMAIL_BANNER_SUCCESS')
export const SET_EMAIL_BANNER_FAILED = makeConstant('SET_EMAIL_BANNER_FAILED')

export const CLEAR_ENROLL_MODAL_STATE = makeConstant('CLEAR_ENROLL_MODAL_STATE')

export const SET_MARKETING_EMAIL_LAYOUT = makeConstant('SET_MARKETING_EMAIL_LAYOUT')

export const FETCH_PLAYBOOKS_BY_GATED_PLAN = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN')
export const FETCH_PLAYBOOKS_BY_GATED_PLAN_PENDING = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN_PENDING')
export const FETCH_PLAYBOOKS_BY_GATED_PLAN_FAILED = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN_FAILED')
export const FETCH_PLAYBOOKS_BY_GATED_PLAN_SUCCESS = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN_SUCCESS')
export const FETCH_PLAYBOOKS_BY_GATED_PLAN_CANCELLED = makeConstant('FETCH_PLAYBOOKS_BY_GATED_PLAN_CANCELLED')

export const SET_END_USER_EMAIL = makeConstant('SET_END_USER_EMAIL')

export const ASYNC_BUTTON_PRESS = makeConstant('ASYNC_BUTTON_PRESS')
export const ASYNC_BUTTON_PRESS_PENDING = makeConstant('ASYNC_BUTTON_PRESS_PENDING')
export const ASYNC_BUTTON_PRESS_FAILED = makeConstant('ASYNC_BUTTON_PRESS_FAILED')
export const ASYNC_BUTTON_PRESS_SUCCESS = makeConstant('ASYNC_BUTTON_PRESS_SUCCESS')
export const ASYNC_BUTTON_PRESS_CANCELLED = makeConstant('ASYNC_BUTTON_PRESS_CANCELLED')

export const SET_EDIT_SENDER_LEVEL = makeConstant('SET_EDIT_SENDER_LEVEL')

export const SET_SIGNATURE_BODY = makeConstant('SET_SIGNATURE_BODY')
export const SET_SIGNATURE_INCLUDE_AVATAR = makeConstant('SET_SIGNATURE_INCLUDE_AVATAR')
export const SET_SIGNATURE_INCLUDE_SOCIAL = makeConstant('SET_SIGNATURE_INCLUDE_SOCIAL')
export const SET_SIGNATURE_INCLUDE_BANNER = makeConstant('SET_SIGNATURE_INCLUDE_BANNER')
export const SET_SIGNATURE_BANNER_IMG_URL = makeConstant('SET_SIGNATURE_BANNER_IMG_URL')
export const SET_SIGNATURE_BANNER_LINK_URL = makeConstant('SET_SIGNATURE_BANNER_LINK_URL')

export const SET_VIEWING_SIGNATURE_ID = makeConstant('SET_VIEWING_SIGNATURE_ID')
export const ADD_NEW_SIGNATURE_TO_PLAYBOOK = makeConstant('ADD_NEW_SIGNATURE_TO_PLAYBOOK')
export const REMOVE_SIGNATURE = makeConstant('REMOVE_SIGNATURE')
export const ADD_EMPTY_BANNER_SIGNATURE = makeConstant('ADD_EMPTY_BANNER_SIGNATURE')
export const REMOVE_EMPTY_BANNER_SIGNATURE = makeConstant('REMOVE_EMPTY_BANNER_SIGNATURE')

export const CLEAR_SIGNATURE_BANNER = makeConstant('CLEAR_SIGNATURE_BANNER')
export const SET_SIGNATURE_BANNER = makeConstant('SET_SIGNATURE_BANNER')
export const SET_SIGNATURE_BANNER_PENDING = makeConstant('SET_SIGNATURE_BANNER_PENDING')
export const SET_SIGNATURE_BANNER_FAILED = makeConstant('SET_SIGNATURE_BANNER_FAILED')
export const SET_SIGNATURE_BANNER_SUCCESS = makeConstant('SET_SIGNATURE_BANNER_SUCCESS')
export const SET_SIGNATURE_BANNER_CANCELLED = makeConstant('SET_SIGNATURE_BANNER_CANCELLED')

export const FETCH_SIGNATURE_MULTI_BANNER_PREVIEW = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW')
export const FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_PENDING = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_PENDING')
export const FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_FAILED = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_FAILED')
export const FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_SUCCESS = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_SUCCESS')
export const FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_CANCELLED = makeConstant('FETCH_SIGNATURE_MULTI_BANNER_PREVIEW_CANCELLED')

export const FETCH_SIGNATURE_PLAYBOOK_PREVIEW = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW')
export const FETCH_SIGNATURE_PLAYBOOK_PREVIEW_PENDING = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW_PENDING')
export const FETCH_SIGNATURE_PLAYBOOK_PREVIEW_FAILED = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW_FAILED')
export const FETCH_SIGNATURE_PLAYBOOK_PREVIEW_SUCCESS = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW_SUCCESS')
export const FETCH_SIGNATURE_PLAYBOOK_PREVIEW_CANCELLED = makeConstant('FETCH_SIGNATURE_PLAYBOOK_PREVIEW_CANCELLED')

export const CREATE_INITIAL_WELCOME_PLAYBOOKS = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS')
export const CREATE_INITIAL_WELCOME_PLAYBOOKS_PENDING = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS_PENDING')
export const CREATE_INITIAL_WELCOME_PLAYBOOKS_FAILED = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS_FAILED')
export const CREATE_INITIAL_WELCOME_PLAYBOOKS_SUCCESS = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS_SUCCESS')
export const CREATE_INITIAL_WELCOME_PLAYBOOKS_CANCELLED = makeConstant('CREATE_INITIAL_WELCOME_PLAYBOOKS_CANCELLED')

export const FETCH_PLAYBOOK_FOR_CAMPAIGN_ID = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID')
export const FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_PENDING = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_PENDING')
export const FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_FAILED = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_FAILED')
export const FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_SUCCESS = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_SUCCESS')
export const FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_CANCELLED = makeConstant('FETCH_PLAYBOOK_FOR_CAMPAIGN_ID_CANCELLED')

export const FETCH_CHAT_ACTIVE_PLAYBOOKS = makeConstant('FETCH_CHAT_ACTIVE_PLAYBOOKS')
export const START_REPORT_TIMER = makeConstant('START_REPORT_TIMER')
export const INCREMENT_REPORT_TIMER = makeConstant('INCREMENT_REPORT_TIMER')
export const DECREMENT_REPORT_TIMER = makeConstant('DECREMENT_REPORT_TIMER')
export const RECORDED_REPORT_TIMER = makeConstant('RECORDED_REPORT_TIMER')

// this is for UI filtering
export const PlaybookStatus = Object.freeze({
  ACTIVE: 'ACTIVE', // rollup of enabled & disabled, WIP
  EMAIL: 'EMAIL', // rollup of email, sent, and sequences
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  ARCHIVED: 'ARCHIVED',
  SCHEDULED: 'SCHEDULED',
  SENT: 'SENT',
  DELETED: 'DELETED',
})

export const EditSenderLevels = Object.freeze({
  GLOBAL: 'global', // edit the sender over the whole playbook
  LOCAL: 'local', // edit the sender over each email
})

export const EmailPreviewView = {
  TEMPLATE: 'template',
  DEFAULTS: 'defaults',
  RENDERED_DATA: 'renderedData',
}

export const AudienceType = Object.freeze({
  SEGMENT: 'SEGMENT',
  VISITORS: 'VISITORS',
  USERS: 'USERS',
  EVERYONE: 'EVERYONE',
  NONE: 'NONE',
})

export const AudienceDisplay = Object.freeze({
  SEGMENT: 'Segment(s)',
  VISITORS: 'Visitors',
  USERS: 'Known Users',
  EVERYONE: 'Everyone',
  NONE: 'None',
})

export const PlaybooksFrequency = Object.freeze({
  ONCE: 'ONCE',
  SESSION: 'ONCE_PER_SESSION',
  ALWAYS: 'ALWAYS',
})

export const AudienceIcons = Object.freeze({
  VISITORS: siteVisitorsSrc,
  USERS: knownUsersSrc,
})

export const TargetingDisplay = Object.freeze({
  ALWAYS: 'Always',
  NONE: '#DriftLink only',
})

export const SmartFilterValues = Object.freeze({
  INCLUDE: 'INCLUDE',
  EXCLUDE: 'EXCLUDE',
})

export const PlaybookReportType = Object.freeze({
  BOOK_MORE_MEETINGS: 'BOOK_MORE_MEETINGS',
  MORE_QUALIFIED_CONVERSATIONS: 'MORE_QUALIFIED_CONVERSATIONS',
  MORE_SALES_CONVERSATIONS: 'MORE_SALES_CONVERSATIONS',
  DRIVE_TRAFFIC_TARGETED_MESSAGE: 'DRIVE_TRAFFIC_TARGETED_MESSAGE',
  PROMOTION_FULL_SCREEN_TAKEOVER: 'PROMOTION_FULL_SCREEN_TAKEOVER',
  SEND_AN_AUTOMATED_EMAIL: 'SEND_AN_AUTOMATED_EMAIL',
  SEND_A_ONETIME_EMAIL: 'SEND_A_ONETIME_EMAIL',
  TALK_TO_YOUR_OUTBOUND_PROSPECTS: 'TALK_TO_YOUR_OUTBOUND_PROSPECTS',
  BUILD_A_SUBSCRIBER_LIST: 'BUILD_A_SUBSCRIBER_LIST',
  EMPTY_LEADBOT: 'EMPTY_LEADBOT',
  EMPTY_SLIDER: 'EMPTY_SLIDER',
  EMPTY_TAKEOVER: 'EMPTY_TAKEOVER',
  EMPTY_WELCOME_MESSAGE: 'EMPTY_WELCOME_MESSAGE',
  NPS_BOT: 'NPS_BOT',
  ABM: 'ABM',
  OUTBOUND_SEQUENCE: 'OUTBOUND_SEQUENCE',
  MARKETING_SEQUENCE: 'MARKETING_SEQUENCE',
  MARKETING_ONE_TIME_SEQUENCE: 'MARKETING_ONE_TIME_SEQUENCE',
  BLOG_NURTURE: 'BLOG_NURTURE',
  NEW_BLOG_CONTENT: 'NEW_BLOG_CONTENT',
  NEWSLETTER: 'NEWSLETTER',
  PRODUCT_ANNOUNCEMENT: 'PRODUCT_ANNOUNCEMENT',
  ABANDONED_BOOK_A_MEETING: 'ABANDONED_BOOK_A_MEETING',
  SIGNATURE: 'SIGNATURE',
  LANDING_PAGE_LEADBOT: 'LANDING_PAGE_LEADBOT',
  VSB_DEFAULT_PLAYBOOK: 'VSB_DEFAULT_PLAYBOOK',
  CONVERSATION_STARTER_BOT: 'CONVERSATION_STARTER_BOT',
  RETARGETING_BOT: 'RETARGETING_BOT',
  PRICING_PAGE_BOT: 'PRICING_PAGE_BOT',
  SECOND_NET_BOT: 'SECOND_NET_BOT',
  ABM_HOMEPAGE_BOT: 'ABM_HOMEPAGE_BOT',
  PAID_TRAFFIC_BOT: 'PAID_TRAFFIC_BOT',
  FORM_REPLACER_CLP: 'FORM_REPLACER_CLP',
  CONVO_CONTENT_CLP: 'CONVO_CONTENT_CLP',
  ENTERPRISE_BOT: 'ENTERPRISE_BOT'
})

export const chatPlaybookReportTypes = [
  PlaybookReportType.BOOK_MORE_MEETINGS,
  PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS,
  PlaybookReportType.MORE_SALES_CONVERSATIONS,
  PlaybookReportType.DRIVE_TRAFFIC_TARGETED_MESSAGE,
  PlaybookReportType.PROMOTION_FULL_SCREEN_TAKEOVER,
  PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS,
  PlaybookReportType.BUILD_A_SUBSCRIBER_LIST,
  PlaybookReportType.EMPTY_LEADBOT,
  PlaybookReportType.ENTERPRISE_BOT,
  PlaybookReportType.EMPTY_SLIDER,
  PlaybookReportType.EMPTY_TAKEOVER,
  PlaybookReportType.EMPTY_WELCOME_MESSAGE,
  PlaybookReportType.NPS_BOT,
  PlaybookReportType.ABM,
  PlaybookReportType.LANDING_PAGE_LEADBOT,
  PlaybookReportType.VSB_DEFAULT_PLAYBOOK,
  PlaybookReportType.CONVERSATION_STARTER_BOT,
  PlaybookReportType.RETARGETING_BOT,
  PlaybookReportType.PRICING_PAGE_BOT,
  PlaybookReportType.SECOND_NET_BOT,
  PlaybookReportType.ABM_HOMEPAGE_BOT,
  PlaybookReportType.PAID_TRAFFIC_BOT,
  PlaybookReportType.FORM_REPLACER_CLP,
  PlaybookReportType.CONVO_CONTENT_CLP
]

export const landingPagePlaybookReportTypes = [
  PlaybookReportType.LANDING_PAGE_LEADBOT,
  PlaybookReportType.FORM_REPLACER_CLP,
  PlaybookReportType.CONVO_CONTENT_CLP
]

export const botPlaybookReportTypes = [
  PlaybookReportType.BOOK_MORE_MEETINGS,
  PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS,
  PlaybookReportType.EMPTY_LEADBOT,
  PlaybookReportType.ENTERPRISE_BOT,
  PlaybookReportType.NPS_BOT,
  PlaybookReportType.LANDING_PAGE_LEADBOT,
  PlaybookReportType.VSB_DEFAULT_PLAYBOOK,
  PlaybookReportType.CONVERSATION_STARTER_BOT,
  PlaybookReportType.RETARGETING_BOT,
  PlaybookReportType.PRICING_PAGE_BOT,
  PlaybookReportType.SECOND_NET_BOT,
  PlaybookReportType.ABM_HOMEPAGE_BOT,
  PlaybookReportType.PAID_TRAFFIC_BOT,
  PlaybookReportType.FORM_REPLACER_CLP,
  PlaybookReportType.CONVO_CONTENT_CLP
]

export const isLandingPagePlaybook = reportType => landingPagePlaybookReportTypes.includes(reportType)

export const isNonLandingPageBotPlaybook = reportType => {
  return botPlaybookReportTypes.includes(reportType) && !landingPagePlaybookReportTypes.includes(reportType)
}

export const isLeadBotPlaybook = reportType => {
  return botPlaybookReportTypes.includes(reportType)
}

export const isEmailPlaybook = reportType => {
  return (
    reportType === PlaybookReportType.SEND_AN_AUTOMATED_EMAIL ||
    reportType === PlaybookReportType.SEND_A_ONETIME_EMAIL ||
    reportType === PlaybookReportType.SEND_A_ONETIME_OUTBOUND_EMAIL ||
    reportType === PlaybookReportType.OUTBOUND_SEQUENCE ||
    reportType === PlaybookReportType.MARKETING_SEQUENCE ||
    reportType === PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE ||
    reportType === PlaybookReportType.BLOG_NURTURE ||
    reportType === PlaybookReportType.NEW_BLOG_CONTENT ||
    reportType === PlaybookReportType.NEWSLETTER ||
    reportType === PlaybookReportType.PRODUCT_ANNOUNCEMENT ||
    reportType === PlaybookReportType.ABANDONED_BOOK_A_MEETING ||
    reportType === PlaybookReportType.VSB_DEFAULT_PLAYBOOK
  )
}

export const isOneTimeEmailPlaybook = reportType => {
  return (
    reportType === PlaybookReportType.SEND_A_ONETIME_EMAIL ||
    reportType === PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE ||
    reportType === PlaybookReportType.NEW_BLOG_CONTENT ||
    reportType === PlaybookReportType.NEWSLETTER ||
    reportType === PlaybookReportType.PRODUCT_ANNOUNCEMENT
  )
}

export const isSignaturePlaybook = reportType => {
  return (
    reportType === PlaybookReportType.SIGNATURE
  )
}

export const isSalesSequencePlaybook = reportType => {
  return (
    reportType === PlaybookReportType.OUTBOUND_SEQUENCE
  )
}

export const ReportTypeToTableName = Object.freeze({
  [PlaybookReportType.BLOG_NURTURE]: 'Triggered email',
  [PlaybookReportType.MARKETING_SEQUENCE]: 'Triggered email',
  [PlaybookReportType.SEND_AN_AUTOMATED_EMAIL]: 'Triggered email',
  [PlaybookReportType.ABANDONED_BOOK_A_MEETING]: 'Triggered email',
  [PlaybookReportType.NEWSLETTER]: 'One-time email',
  [PlaybookReportType.NEW_BLOG_CONTENT]: 'One-time email',
  [PlaybookReportType.PRODUCT_ANNOUNCEMENT]: 'One-time email',
  [PlaybookReportType.SEND_A_ONETIME_EMAIL]: 'One-time email',
  [PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE]: 'One-time email',
  [PlaybookReportType.OUTBOUND_SEQUENCE]: 'Sales email sequence',
  [PlaybookReportType.NPS_BOT]: 'Bot',
  [PlaybookReportType.EMPTY_LEADBOT]: 'Bot',
  [PlaybookReportType.ENTERPRISE_BOT]: 'Bot',
  [PlaybookReportType.BOOK_MORE_MEETINGS]: 'Bot',
  [PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS]: 'Bot',
  [PlaybookReportType.LANDING_PAGE_LEADBOT]: 'Bot',
  [PlaybookReportType.VSB_DEFAULT_PLAYBOOK]: 'Bot',
  [PlaybookReportType.BUILD_A_SUBSCRIBER_LIST]: 'Email capture',
  [PlaybookReportType.ABM]: 'Live chat',
  [PlaybookReportType.EMPTY_WELCOME_MESSAGE]: 'Live chat',
  [PlaybookReportType.MORE_SALES_CONVERSATIONS]: 'Live chat',
  [PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS]: 'Live chat',
  [PlaybookReportType.EMPTY_SLIDER]: 'Slider',
  [PlaybookReportType.DRIVE_TRAFFIC_TARGETED_MESSAGE]: 'Slider',
  [PlaybookReportType.EMPTY_TAKEOVER]: 'Takeover',
  [PlaybookReportType.PROMOTION_FULL_SCREEN_TAKEOVER]: 'Takeover',
  [PlaybookReportType.CONVERSATION_STARTER_BOT]: 'Bot',
  [PlaybookReportType.RETARGETING_BOT]: 'Bot',
  [PlaybookReportType.PRICING_PAGE_BOT]: 'Bot',
  [PlaybookReportType.SECOND_NET_BOT]: 'Bot',
  [PlaybookReportType.ABM_HOMEPAGE_BOT]: 'Bot',
  [PlaybookReportType.PAID_TRAFFIC_BOT]: 'Bot',
  [PlaybookReportType.FORM_REPLACER_CLP]: 'Bot',
  [PlaybookReportType.CONVO_CONTENT_CLP]: 'Bot'
})

export const CtaTypes = Object.freeze({
  CHAT: 'CHAT_RESPONSE',
  URL: 'URL_LINK',
  MEETING: 'SCHEDULE_MEETING',
  NONE: 'NONE',
})

export const CtaGoalTypes = Object.freeze({
  CHAT_RESPONSE: 'conversation_started',
  URL_LINK: 'clicked',
  SCHEDULE_MEETING: 'conversation_started',
  NONE: 'none',
})

export const MarketingEmailLayouts = Object.freeze({
  SIMPLE: 'SIMPLE',
  WITH_COMPANY_LOGO: 'WITH_COMPANY_LOGO',
  WITH_HERO_IMAGE: 'WITH_HERO_IMAGE',
})

export const MarketingEmailSubTypes = Object.freeze({
  AUTOMATED: 'AUTOMATED',
  ONE_TIME: 'ONE_TIME',
})

export const ActionViewConfig = Object.freeze({
  CQL: 'CQL',
})

export const CtaViewConfig = Object.freeze({
  CHAT_RESPONSE: {
    placeholder: 'Type your message...',
    showCopy: true,
    showUrl: false,
  },
  URL_LINK: {
    placeholderUrl: 'https://drift.com',
    placeholder: 'Learn More',
    showCopy: true,
    showUrl: true,
  },
  SCHEDULE_MEETING: {
    placeholder: 'Schedule a Meeting',
    requiredGates: [Gates.PREMIUM_ENTERPRISE],
    showUrl: false,
    showCopy: true,
  },
  NONE: {
    showCopy: false,
    showUrl: false,
  },
})

export const EmailThemeType = Object.freeze({
  SIMPLE: 'SIMPLE',
  STYLED: 'STYLED',
})

export const PlaybookDefaultEditViewOptions = Object.freeze({
  MESSAGE: 'message',
  SEQUENCE: 'sequence',
})

export const emailSendModes = Object.freeze({
  NOW: 'NOW',
  SCHEDULED: 'SCHEDULED',
})

export const PlaybookViewConfig = Object.freeze({
  [PlaybookReportType.BOOK_MORE_MEETINGS]: {},
  [PlaybookReportType.MORE_QUALIFIED_CONVERSATIONS]: {},
  [PlaybookReportType.LANDING_PAGE_LEADBOT]: {},
  [PlaybookReportType.VSB_DEFAULT_PLAYBOOK]: {},
  [PlaybookReportType.EMPTY_LEADBOT]: {},
  [PlaybookReportType.ENTERPRISE_BOT]: {},
  [PlaybookReportType.NPS_BOT]: {},
  [PlaybookReportType.MORE_SALES_CONVERSATIONS]: {
    messageUrlPath: 'welcome',
    label: 'Live chat',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.EMPTY_WELCOME_MESSAGE]: {
    messageUrlPath: 'welcome',
    label: 'Live chat',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.DRIVE_TRAFFIC_TARGETED_MESSAGE]: {
    messageUrlPath: 'targeted',
    label: 'Announcement',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.EMPTY_SLIDER]: {
    messageUrlPath: 'targeted',
    label: 'Announcement',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.PROMOTION_FULL_SCREEN_TAKEOVER]: {
    messageUrlPath: 'takeover',
    label: 'Announcement',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.EMPTY_TAKEOVER]: {
    messageUrlPath: 'takeover',
    label: 'Announcement',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.SEND_A_ONETIME_EMAIL]: {
    messageUrlPath: 'email',
    previewUrlPath: 'email-preview',
    label: 'Email',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.SEND_AN_AUTOMATED_EMAIL]: {
    messageUrlPath: 'email',
    previewUrlPath: 'email-preview',
    label: 'Email',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.TALK_TO_YOUR_OUTBOUND_PROSPECTS]: {
    messageUrlPath: 'welcome',
    label: 'Live chat',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.BUILD_A_SUBSCRIBER_LIST]: {
    messageUrlPath: 'capture',
    label: 'Email Capture',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.ABM]: {
    messageUrlPath: 'welcome',
    label: 'Live chat',
    default: PlaybookDefaultEditViewOptions.MESSAGE,
  },
  [PlaybookReportType.OUTBOUND_SEQUENCE]: {},
  [PlaybookReportType.MARKETING_SEQUENCE]: {},
  [PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE]: {},
  [PlaybookReportType.BLOG_NURTURE]: {},
  [PlaybookReportType.NEW_BLOG_CONTENT]: {},
  [PlaybookReportType.NEWSLETTER]: {},
  [PlaybookReportType.PRODUCT_ANNOUNCEMENT]: {},
  [PlaybookReportType.ABANDONED_BOOK_A_MEETING]: {},
  [PlaybookReportType.CONVERSATION_STARTER_BOT]: {},
  [PlaybookReportType.RETARGETING_BOT]: {},
  [PlaybookReportType.PRICING_PAGE_BOT]: {},
  [PlaybookReportType.SECOND_NET_BOT]: {},
  [PlaybookReportType.ABM_HOMEPAGE_BOT]: {},
  [PlaybookReportType.PAID_TRAFFIC_BOT]: {},
  [PlaybookReportType.FORM_REPLACER_CLP]: {}
})

export const playbooksCopyDefaults = Object.freeze({
  GOALS:
    'Goals can be used to qualify (or dis-qualify) people who interact with this bot so your team can focus on only the best leads. Routing will kick in once a lead reaches this goal.',
  REVIEW:
    'Once you turn this on, the LeadBot will start booking meetings and qualifying your leads for you, even in your sleep.',
})

export const playbooksCopy = Object.freeze({
  BOOK_MORE_MEETINGS: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  MORE_QUALIFIED_CONVERSATIONS: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  VSB_DEFAULT_PLAYBOOK: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  LANDING_PAGE_LEADBOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  MORE_SALES_CONVERSATIONS: {
    goals:
      "For this playbook, there is only one goal...to have conversations! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review:
      'Once you turn this on, your playbook will start showing up on your pricing page (unless you changed the defaults) and help you have more sales conversations.',
  },
  DRIVE_TRAFFIC_TARGETED_MESSAGE: {
    goals:
      "For this playbook, there is only one goal...to drive traffic! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review:
      "Once you turn this on, your playbook will start showing up on your home page (unless you changed the defaults) and help you drive traffic to whatever URL you've set as the CTA.",
  },
  PROMOTION_FULL_SCREEN_TAKEOVER: {
    goals:
      "For this playbook, there is only one goal...to promote something! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review:
      "Once you turn this on, your playbook will start showing up on your home page (unless you changed the defaults) and help you drive interest in whatever you're promoting.",
  },
  NPS_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  EMPTY_LEADBOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  ENTERPRISE_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  EMPTY_WELCOME_MESSAGE: {
    goals:
      "For this playbook, there is only one goal...to have conversations! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review:
      'Once you turn this on, your playbook will start showing up on your pricing page (unless you changed the defaults) and help you have more sales conversations.',
  },
  EMPTY_SLIDER: {
    goals:
      "For this playbook, there is only one goal...to drive traffic! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review:
      "Once you turn this on, your playbook will start showing up on your home page (unless you changed the defaults) and help you drive traffic to whatever URL you've set as the CTA.",
  },
  EMPTY_TAKEOVER: {
    goals:
      "For this playbook, there is only one goal...to promote something! This goal is pre-set for you and you can change the lead stage name and routing if you'd like.",
    review:
      "Once you turn this on, your playbook will start showing up on your home page (unless you changed the defaults) and help you drive interest in whatever you're promoting.",
  },
  TALK_TO_YOUR_OUTBOUND_PROSPECTS: {
    goals: playbooksCopyDefaults.GOALS,
    review: "Once you turn this on, you’ll start automatically greeting prospects you email from Drift Sequences or the Drift Extension with a personalized message! Have more conversations <b><i>now.</i></b>",
  },
  ABM: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  SEND_AN_AUTOMATED_EMAIL: {
    goals:
      'For this Playbook, there’s only one goal…to send an email and get people to engage with the links you added (CTAs). This goal is pre-set for you and you can change the lead stage name',
    review:
      'Once you turn this on, your playbook will email everyone in the segment you chose. If anybody is added to that segment, they’ll also automatically get emailed.',
  },
  SEND_A_ONETIME_EMAIL: {
    goals:
      'For this Playbook, there’s only one goal…to send an email and get people to engage with the links you added (CTAs). This goal is pre-set for you and you can change the lead stage name',
    review: 'Once you turn this on, your playbook will email everyone in the segment you chose.',
  },
  BUILD_A_SUBSCRIBER_LIST: {
    goals:
      'For this playbook, there is only one goal...to capture an email! This goal is pre-set for you and you can change the lead stage name if you’d like.',
    review:
      'Once you turn this on, your playbook will start showing up on your blog page (unless you changed the defaults) and help you build a blog subscriber list.',
  },
  OUTBOUND_SEQUENCE: {
    review: 'Once your sequence is ready to go and enabled, you can start enrolling contacts!',
  },
  MARKETING_ONE_TIME_SEQUENCE: {
    review: 'Once you turn this on, your playbook will email everyone in your chosen segment(s).',
  },
  MARKETING_SEQUENCE: {
    review:
      'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.',
  },
  BLOG_NURTURE: {
    review:
      'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.',
  },
  NEW_BLOG_CONTENT: {
    review:
      'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.',
  },
  NEWSLETTER: {
    review:
      'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.',
  },
  ABANDONED_BOOK_A_MEETING: {
    review:
      'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.',
  },
  PRODUCT_ANNOUNCEMENT: {
    review:
      'Once you turn this on, your playbook will immediately email everybody in the chosen segments as well as new contacts once they are in the segment.',
  },
  CONVERSATION_STARTER_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  RETARGETING_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  PRICING_PAGE_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  SECOND_NET_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  ABM_HOMEPAGE_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  PAID_TRAFFIC_BOT: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  FORM_REPLACER_CLP: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  },
  CONVO_CONTENT_CLP: {
    goals: playbooksCopyDefaults.GOALS,
    review: playbooksCopyDefaults.REVIEW,
  }
})

export const RoutingType = Object.freeze({
  GLOBAL: 'GLOBAL',
  SINGLE: 'SINGLE',
  GROUP: 'GROUP',
  NONE: null,
})

export const END_CONVERSATION = 'END_CONVERSATION'

export const END_CONVERSATION_OPTION = {
  value: {
    id: END_CONVERSATION,
    isGoal: false,
  },
  label: 'End conversation',
}

export const PROCEED_OPTION = {
  value: {
    id: null,
    isGoal: false,
  },
  label: 'Proceed to next question',
}

export const AnswerType = Object.freeze({
  KEYWORDS: 'KEYWORDS',
  BUTTON: 'BUTTON',
  VALIDATE: 'VALIDATE',
})

export const ValidationType = Object.freeze({
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
})

export const KeywordType = Object.freeze({
  EQUALS: 'EQUALS',
  FUZZY: 'FUZZY',
  CONTAINS: 'CONTAINS',
})

const StateOptions = _.map(UspsCodesToStateName, label => ({ value: label, label }))
const CountryOptions = _.map(IsoToCountriesNames, (label, value) => ({ value, label }))
const CountryNameOptions = _.map(IsoToCountriesNames, (label, value) => ({ label, value: label }))

const OperatorType = {
  GREATER_THAN: 'greaterThan',
  LESS_THAN: 'lessThan',
  IS: 'is',
  NOT_IS: 'notIs',
  IS_ANY_OF: 'isAnyOf',
  NOT_IS_ANY_OF: 'notIsAnyOf',
  INCLUDES_ANY_OF: 'includesAnyOf',
  NOT_INCLUDES_ANY_OF: 'notIncludesAnyOf',
  IS_AVAILABLE: 'isAvailable',
  IS_NOT_AVAILABLE: 'isNotAvailable',
  IS_MATCH: 'isMatch',
  IS_IN_WATCHLIST: 'isInWatchlist',
  NOT_IS_IN_WATCHLIST: 'notIsInWatchlist',
  IS_WATCHLIST_VALUE_NULL: 'isWatchlistValueNull',
  NOT_IS_WATCHLIST_VALUE_NULL: 'notIsWatchlistValueNull'
}

export const OperatorToDisplay = {
  [OperatorType.GREATER_THAN]: 'greater than',
  [OperatorType.LESS_THAN]: 'less than',
  [OperatorType.IS]: 'is',
  [OperatorType.NOT_IS]: 'is not',
  [OperatorType.IS_ANY_OF]: 'is',
  [OperatorType.NOT_IS_ANY_OF]: 'is not',
  [OperatorType.INCLUDES_ANY_OF]: 'includes',
  [OperatorType.NOT_INCLUDES_ANY_OF]: 'does not include',
  [OperatorType.IS_AVAILABLE]: 'is online',
  [OperatorType.IS_NOT_AVAILABLE]: 'is offline',
  [OperatorType.IS_MATCH]: 'matches (regex)',
  [OperatorType.IS_IN_WATCHLIST]: 'has key:value',
  [OperatorType.NOT_IS_IN_WATCHLIST]: 'does not have key:value',
  [OperatorType.IS_WATCHLIST_VALUE_NULL]: 'has a null value',
  [OperatorType.NOT_IS_WATCHLIST_VALUE_NULL]: 'does not have a null value'
}

export const ConditionType = {
  TEAM_AVAILABILITY: 'teamAvailability',
  OUTBOUND_SESSION: 'outboundSession',
  OUTBOUND_REP: 'autoAssigneeId',
  COUNTRY: 'geoCountryCode',
  STATE: 'geoState',
  IP_ADDRESS: 'geoIp',
  DEVICE: 'device',
  SITE_VISITS: 'siteVisits',
  DAYS_SINCE_LAST_VISIT: 'daysSinceLastVisit',
  URL: 'url',
  URL_PATH: 'urlPath',
  URL_HOST: 'urlHost',
  URL_QUERY: 'urlQuery',
  COOKIE: 'cookie',
  SCROLL_PERCENTAGE: 'scrollPct',
  SECONDS_ON_PAGE: 'secondsOnPage',
  SECONDS_ON_SITE: 'secondsOnSite',
  REFERRER: 'referrer',
  WIDGET_STATUS: 'online',
  SEGMENT: 'segment',
  EXIT_INTENT: 'exitIntent',
  CLEARBIT_NAME: 'clearbit_name',
  CLEARBIT_DOMAIN: 'clearbit_domain',
  CLEARBIT_REVENUE: 'clearbit_revenue',
  CLEARBIT_TAGS: 'clearbit_tags',
  CLEARBIT_TECH: 'clearbit_tech',
  CLEARBIT_EMPLOYEES: 'clearbit_employees',
  CLEARBIT_RAISED: 'clearbit_raised',
  CLEARBIT_ALEXA_US: 'clearbit_alexa_us',
  CLEARBIT_ALEXA_GLOBAL: 'clearbit_alexa_global',
  CLEARBIT_HEADQUARTERS_STATE: 'clearbit_state',
  CLEARBIT_HEADQUARTERS_COUNTRY: 'clearbit_country',
  CLEARBIT_HEADQUARTERS_POSTAL_CODE: 'clearbit_postal_code',
  DEMANDBASE_AUDIENCE: 'demandbase_audience',
  DEMANDBASE_WATCHLIST: 'demandbase_watchlist',
  DEMANDBASE_COMPANY_NAME: 'demandbase_company_name',
  DEMANDBASE_INDUSTRY: 'demandbase_industry',
  DEMANDBASE_EMPLOYEE_COUNT: 'demandbase_employee_count',
  DEMANDBASE_EMPLOYEE_RANGE: 'demandbase_employee_range',
  DEMANDBASE_CITY: 'demandbase_city',
  DEMANDBASE_STATE: 'demandbase_state',
  DEMANDBASE_COUNTRY_CODE: 'demandbase_country_code',
  DEMANDBASE_MARKETING_ALIAS: 'demandbase_marketing_alias',
  DEMANDBASE_SUB_INDUSTRY: 'demandbase_sub_industry',
  DEMANDBASE_ANNUAL_SALES: 'demandbase_annual_sales',
  DEMANDBASE_REVENUE_RANGE: 'demandbase_revenue_range',
  DEMANDBASE_COUNTRY_NAME: 'demandbase_country_name',
  MADKUDU_SCORE: 'madkudu_score',
  TARGET_ACCOUNT: 'targetAccount',
  EMAIL_PLAYBOOK: 'email_playbook',
}

const DeviceOptions = [
  { value: 'mobile', label: 'mobile' },
  { value: 'tablet', label: 'tablet' },
  { value: 'desktop', label: 'desktop' },
]

const MadkuduScoreOptions = [
  { label: 'Very Good', value: 'very good' },
  { label: 'Good', value: 'good' },
  { label: 'Medium', value: 'medium' },
  { label: 'Low', value: 'low' },
]

export const MadkuduLabelMap = {
  ['very good']: 'Very Good',
  ['good']: 'Good',
  ['medium']: 'OK',
  ['low']: 'Poor',
}
export const MadkuduSignalMap = {
  ['personal email address']: 'Personal Email',
  ['spam']: 'Spam',
  ['fortune 500']: 'Fortune 500',
  ['firmographics profile']: 'Firmographics Profile',
  ['potentially spam']: 'Spam (potential)',
  ['education']: 'Education',
  ['employee count']: 'Employee Count',
  ['number of employees']: 'Number of Employees',
  ['team email']: 'Team Email',
  ['nonprofit']: 'Non-Profit',
  ['test email']: 'Test Email',
  ['market cap']: 'Market Cap',
  ['capital raised']: 'Capital Raised',
  ['web traffic volume']: 'Web Traffic Volume',
  ['based in a country where gdp per capita']: 'Country GDP per Capita',
  ['enterprise tech found on website']: 'Enterprise Tech on Web Site',
  ['belongs to industry where revenue per employee']: 'Industrial Revenue per Employee',
  ['number of tech found on website']: 'Tech on Web Site',
  ['twitter followers']: 'Twitter Followers',
  ['company founding year']: 'Company Founding Year',
  ['Company size']: 'Company size is',
}

const BooleanOptions = [{ value: true, label: 'true' }, { value: false, label: 'false' }]

const ClearbitTagsOptions = ClearbitTags.map(tag => ({ value: tag, label: tag }))

const ClearbitRevenueOptions = ClearbitRevenueRanges.map(range => ({ value: range, label: range }))

const DemandbaseEmployeeRangeOptions = DemandbaseEmployeeRanges.map(value => ({ label: value, value: value }))
const DemandbaseRevenueRangeOptions = DemandbaseRevenueRanges.map(value => ({ label: value, value: value }))


export const ConditionCategory = Object.freeze({
  URL: 'URL',
  EMAIL_PLAYBOOK: 'EMAIL_PLAYBOOK',
  BROWSER: 'BROWSER',
  GEOGRAPHY: 'GEOGRAPHY',
  ENRICHMENT: 'ENRICHMENT',
  DRIFT: 'DRIFT',
  SEGMENT: 'SEGMENT',
})

export const ConditionCategoryToDisplay = Object.freeze({
  [ConditionCategory.URL]: 'URL',
  [ConditionCategory.EMAIL_PLAYBOOK]: 'Came from email playbook',
  [ConditionCategory.BROWSER]: 'Website Behavior',
  [ConditionCategory.GEOGRAPHY]: 'Geolocation',
  [ConditionCategory.ENRICHMENT]: 'Firmographics',
  [ConditionCategory.DRIFT]: 'Drift',
  [ConditionCategory.SEGMENT]: 'Segment Membership',
})

export const NEW_EDITOR_PLAYBOOK_TYPES = [
  'EMPTY_LEADBOT',
  'ENTERPRISE_BOT',
  'BOOK_MORE_MEETINGS',
  'MORE_QUALIFIED_CONVERSATIONS',
  'LANDING_PAGE_LEADBOT',
  'VSB_DEFAULT_PLAYBOOK',
  'CONVERSATION_STARTER_BOT',
  'RETARGETING_BOT',
  'PRICING_PAGE_BOT',
  'SECOND_NET_BOT',
  'ABM_HOMEPAGE_BOT',
  'PAID_TRAFFIC_BOT',
  'FORM_REPLACER_CLP',
  'CONVO_CONTENT_CLP'
]

export const ConditionTypes = OrderedMap({
  [ConditionType.URL]: {
    displayName: 'URL',
    Component: StringsInput,
    operators: [
      OperatorType.INCLUDES_ANY_OF,
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF,
      OperatorType.NOT_INCLUDES_ANY_OF,
      OperatorType.IS_MATCH,
    ],
    defaultValue: List.of(''),
    placeholder: 'www.drift.com/',
    showPreview: value => (
      <div>
        <span>{value.first() || 'www.drift.com/'}</span>
      </div>
    ),
    category: ConditionCategory.URL,
    description:
      'This is the fully qualified URL. If you select "includes", it can match any part of the URL, but "is" must exactly match what shows up in the browser.',
  },
  [ConditionType.URL_PATH]: {
    displayName: 'URL Path',
    Component: StringsInput,
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF,
      OperatorType.INCLUDES_ANY_OF,
      OperatorType.NOT_INCLUDES_ANY_OF,
    ],
    defaultValue: List.of(''),
    placeholder: '/blog',
    category: ConditionCategory.URL,
    showPreview: value => (
      <div>
        https://yourdomain.com<span>{value.first() || '/path/to/page'}</span>?example=true
      </div>
    ),
    description:
      'That "path" is the part of the URL that displays from the first "/" after the domain until the first "?" (or until the end of the URL, if there is no "?").',
  },
  [ConditionType.URL_QUERY]: {
    displayName: 'URL Query Param',
    Component: StringsInput,
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF,
      OperatorType.INCLUDES_ANY_OF,
      OperatorType.NOT_INCLUDES_ANY_OF,
    ],
    defaultValue: List.of(''),
    placeholder: 'beta=true',
    showPreview: value => (
      <div>
        https://yourdomain.com/page?<span>{value.join('&') || 'example=true'}</span>
      </div>
    ),
    category: ConditionCategory.URL,
    description:
      'The query parameters of a URL are one or more strings that follow the format key=value, with a "&" between them.\nQuery parameters that are not of the format key=value are invalid and will be ignored.',
  },
  [ConditionType.URL_HOST]: {
    displayName: 'URL Host',
    Component: StringsInput,
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF,
      OperatorType.INCLUDES_ANY_OF,
      OperatorType.NOT_INCLUDES_ANY_OF,
    ],
    defaultValue: List.of(''),
    placeholder: 'app.drift.com',
    category: ConditionCategory.URL,
    showPreview: value => (
      <div>
        https://<span>{value.first() || 'yourdomain'}</span>/page?example=true
      </div>
    ),
    description:
      'This is the domain of the url. It is at least the domain name and the top level domain, e.g. drift (domain name) and .com (top level domain).\nIt may also contain a subdomain, which might look like: app.drift.com',
  },
  [ConditionType.SECONDS_ON_PAGE]: {
    displayName: 'Seconds on Page',
    Component: NumberInput,
    operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 10,
    category: ConditionCategory.BROWSER,
  },
  [ConditionType.SECONDS_ON_SITE]: {
    displayName: 'Seconds on Site',
    Component: NumberInput,
    operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 60,
    category: ConditionCategory.BROWSER,
  },
  [ConditionType.REFERRER]: {
    displayName: 'Referrer',
    Component: StringsInput,
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF,
      OperatorType.INCLUDES_ANY_OF,
      OperatorType.NOT_INCLUDES_ANY_OF,
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.BROWSER,
  },
  [ConditionType.COOKIE]: {
    displayName: 'Cookie',
    Component: compose(withProps(() => ({ placeholder: 'cookieName=value' })))(StringsInput),
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF,
      OperatorType.INCLUDES_ANY_OF,
      OperatorType.NOT_INCLUDES_ANY_OF,
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.BROWSER,
  },
  [ConditionType.DEVICE]: {
    displayName: 'Device',
    Component: withProps(() => ({ options: DeviceOptions }))(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of('mobile'),
    category: ConditionCategory.BROWSER,
  },
  [ConditionType.SITE_VISITS]: {
    displayName: '# Site Visits',
    Component: NumberInput,
    operators: [OperatorType.IS, OperatorType.NOT_IS, OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 3,
    category: ConditionCategory.BROWSER,
  },
  [ConditionType.DAYS_SINCE_LAST_VISIT]: {
    displayName: '# Days Since Last Visit',
    Component: NumberInput,
    operators: [OperatorType.IS, OperatorType.NOT_IS, OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 3,
    category: ConditionCategory.BROWSER,
  },
  [ConditionType.SCROLL_PERCENTAGE]: {
    displayName: 'Scroll Percentage',
    Component: NumberInput,
    operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 70,
    category: ConditionCategory.BROWSER,
  },
  [ConditionType.EXIT_INTENT]: {
    displayName: 'On Exit Intent',
    Component: withProps(() => ({ options: [{ value: true, label: 'true' }]}))(SelectContainer),
    operators: [OperatorType.IS],
    defaultValue: true,
    category: ConditionCategory.BROWSER,
  },
  [ConditionType.COUNTRY]: {
    displayName: 'Country',
    Component: compose(
      withProps(() => ({ options: CountryOptions })),
      withHandlers({ getValueDisplay: () => value => IsoToCountriesNames[value] })
    )(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of('US'),
    getValueDisplay: value => IsoToCountriesNames[value],
    category: ConditionCategory.GEOGRAPHY,
  },
  [ConditionType.STATE]: {
    displayName: 'US State',
    Component: withProps(() => ({ options: StateOptions }))(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of('California'),
    category: ConditionCategory.GEOGRAPHY,
  },
  [ConditionType.IP_ADDRESS]: {
    displayName: 'IP Address',
    Component: compose(withProps(() => ({ placeholder: '192.0.2.2' })))(StringsInput),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of(''),
    category: ConditionCategory.GEOGRAPHY,
  },
  [ConditionType.WIDGET_STATUS]: {
    displayName: 'Drift Online',
    Component: withProps(() => ({ options: BooleanOptions }))(SelectContainer),
    operators: [OperatorType.IS],
    defaultValue: true,
    getValueDisplay: value => (!!value ? 'true' : 'false'),
    category: ConditionCategory.DRIFT,
  },
  [ConditionType.TEAM_AVAILABILITY]: {
    displayName: 'Team',
    requiredGate: 'has_beta_team_view',
    Component: compose(
      withOrgTeams,
      withProps(({ teams }) => ({ options: teams.map(team => ({ value: team.id, label: team.name })) })),
      withHandlers({
        getValueDisplay: ({ teams }) => teamId => {
          const team = teams.find(t => t.id === teamId)
          return !!team ? team.name : ''
        },
      })
    )(SelectsContainer),
    operators: [OperatorType.IS_AVAILABLE, OperatorType.IS_NOT_AVAILABLE],
    defaultValue: List.of(''),
    category: ConditionCategory.DRIFT,
  },
  [ConditionType.DEMANDBASE_AUDIENCE]: {
    displayName: 'Demandbase - Audience',
    requiredIntegration: 'demandbase',
    Component: withProps(() => ({ options: DemandbaseAudiences }))(SelectsContainer),
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF
    ],
    defaultValue: List.of(DemandbaseAudiences[0].value),
    category: ConditionCategory.ENRICHMENT
  },
  [ConditionType.DEMANDBASE_WATCHLIST]: {
    displayName: 'Demandbase - Watch List',
    requiredIntegration: 'demandbase',
    Component: compose(withProps(() => ({ placeholder: 'accountOwner:dave' })))(StringsInput),
    operators: [
      OperatorType.IS_IN_WATCHLIST,
      OperatorType.NOT_IS_IN_WATCHLIST,
      OperatorType.IS_WATCHLIST_VALUE_NULL,
      OperatorType.NOT_IS_WATCHLIST_VALUE_NULL
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.ENRICHMENT
  },
  [ConditionType.DEMANDBASE_COMPANY_NAME]: {
    displayName: 'Demandbase - Company Name',
    requiredIntegration: 'demandbase',
    Component: compose(withProps(() => ({ placeholder: 'Drift' })))(StringsInput),
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF,
      OperatorType.INCLUDES_ANY_OF,
      OperatorType.NOT_INCLUDES_ANY_OF
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.ENRICHMENT
  },
  [ConditionType.DEMANDBASE_INDUSTRY]: {
    displayName: 'Demandbase - Industry',
    requiredIntegration: 'demandbase',
    Component: compose(withProps(() => ({ creatable: true, placeholder: 'Type to create custom value' })))(SelectsContainer),
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF
    ],
    defaultValue: List.of(''),
    externalOptionsProp: 'demandbaseIndustries',
    category: ConditionCategory.ENRICHMENT
  },
  [ConditionType.DEMANDBASE_SUB_INDUSTRY]: {
    displayName: 'Demandbase - Sub Industry',
    requiredIntegration: 'demandbase',
    Component: compose(withProps(() => ({ creatable: true })))(SelectsContainer),
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF
    ],
    placeholder: 'Type to create custom value',
    defaultValue: List.of(''),
    externalOptionsProp: 'demandbaseSubIndustries',
    category: ConditionCategory.ENRICHMENT
  },
  [ConditionType.DEMANDBASE_EMPLOYEE_COUNT]: {
    displayName: 'Demandbase - Employee Count',
    requiredIntegration: 'demandbase',
    Component: NumberInput,
    operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 50,
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.DEMANDBASE_EMPLOYEE_RANGE]: {
    displayName: 'Demandbase - Employee Range',
    requiredIntegration: 'demandbase',
    Component: withProps(() => ({
      creatable: true,
      options: DemandbaseEmployeeRangeOptions,
      placeholder: 'Type to create custom value'
    }))(SelectsContainer),
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.ENRICHMENT
  },
  [ConditionType.DEMANDBASE_MARKETING_ALIAS]: {
    displayName: 'Demandbase - Marketing Alias',
    requiredIntegration: 'demandbase',
    Component: compose(withProps(() => ({ placeholder: 'Demandbase' })))(StringsInput),
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.ENRICHMENT
  },
  [ConditionType.DEMANDBASE_ANNUAL_SALES]: {
    displayName: 'Demandbase - Annual Sales',
    requiredIntegration: 'demandbase',
    Component: NumberInput,
    operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 400000,
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.DEMANDBASE_REVENUE_RANGE]: {
    displayName: 'Demandbase - Revenue Range',
    requiredIntegration: 'demandbase',
    Component: withProps(() => ({
      creatable: true,
      options: DemandbaseRevenueRangeOptions,
      placeholder: 'Type to create custom value'
    }))(SelectsContainer),
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.ENRICHMENT
  },
  [ConditionType.DEMANDBASE_CITY]: {
    displayName: 'Demandbase - City',
    requiredIntegration: 'demandbase',
    Component: compose(withProps(() => ({ placeholder: 'Boston' })))(StringsInput),
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.ENRICHMENT
  },
  [ConditionType.DEMANDBASE_STATE]: {
    displayName: 'Demandbase - State',
    requiredIntegration: 'demandbase',
    Component: withProps(() => ({ options: StateOptions }))(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of('California'),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.DEMANDBASE_COUNTRY_CODE]: {
    displayName: 'Demandbase - Country Code',
    requiredIntegration: 'demandbase',
    Component: compose(
      withProps(() => ({ options: CountryOptions })),
      withHandlers({ getValueDisplay: () => value => IsoToCountriesNames[value] })
    )(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of('US'),
    getValueDisplay: value => IsoToCountriesNames[value],
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.DEMANDBASE_COUNTRY_NAME]: {
    displayName: 'Demandbase - Country Name',
    requiredIntegration: 'demandbase',
    Component: compose(
      withProps(() => ({ options: CountryNameOptions })),
    )(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of('United States'),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_NAME]: {
    displayName: 'Drift Intel - Name',
    requiredGate: 'has_targeting_reveal',
    Component: StringsInput,
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF,
      OperatorType.INCLUDES_ANY_OF,
      OperatorType.NOT_INCLUDES_ANY_OF,
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_DOMAIN]: {
    displayName: 'Drift Intel - Domain',
    requiredGate: 'has_targeting_reveal',
    Component: StringsInput,
    operators: [
      OperatorType.IS_ANY_OF,
      OperatorType.NOT_IS_ANY_OF,
      OperatorType.INCLUDES_ANY_OF,
      OperatorType.NOT_INCLUDES_ANY_OF,
    ],
    defaultValue: List.of(''),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_REVENUE]: {
    displayName: 'Drift Intel - Revenue',
    requiredGate: 'has_targeting_reveal',
    Component: withProps(() => ({ options: ClearbitRevenueOptions }))(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of(ClearbitRevenueRanges[0]),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_TAGS]: {
    displayName: 'Drift Intel - Tags',
    requiredGate: 'has_targeting_reveal',
    Component: withProps(() => ({ options: ClearbitTagsOptions }))(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of(null),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_TECH]: {
    displayName: 'Drift Intel - Tech',
    requiredGate: 'has_targeting_reveal',
    Component: withProps(() => ({ options: ClearbitTechOptions }))(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of(null),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_EMPLOYEES]: {
    displayName: 'Drift Intel - # of Employees',
    requiredGate: 'has_targeting_reveal',
    Component: NumberInput,
    operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 50,
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_RAISED]: {
    displayName: 'Drift Intel - Amount Raised',
    requiredGate: 'has_targeting_reveal',
    Component: NumberInput,
    operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 100000,
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_ALEXA_US]: {
    displayName: 'Drift Intel - Alexa US Ranking',
    requiredGate: 'has_targeting_reveal',
    Component: NumberInput,
    operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 10000000,
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_ALEXA_GLOBAL]: {
    displayName: 'Drift Intel - Alexa Global Ranking',
    requiredGate: 'has_targeting_reveal',
    Component: withProps({ min: 0, max: 100 })(NumberInput),
    operators: [OperatorType.GREATER_THAN, OperatorType.LESS_THAN],
    defaultValue: 10000000,
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_HEADQUARTERS_STATE]: {
    displayName: 'Drift Intel - Headquarter State',
    Component: withProps(() => ({ options: StateOptions }))(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of('California'),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_HEADQUARTERS_COUNTRY]: {
    displayName: 'Drift Intel - Headquarter Country',
    Component: compose(
      withProps(() => ({ options: CountryOptions })),
      withHandlers({ getValueDisplay: () => value => IsoToCountriesNames[value] })
    )(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of('US'),
    getValueDisplay: value => IsoToCountriesNames[value],
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.CLEARBIT_HEADQUARTERS_POSTAL_CODE]: {
    displayName: 'Drift Intel - Headquarter Postal Code',
    Component: StringsInput,
    operators: [OperatorType.IS_ANY_OF, OperatorType.NOT_IS_ANY_OF],
    defaultValue: List.of(''),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.MADKUDU_SCORE]: {
    displayName: 'MadKudu Customer Fit',
    requiredGate: 'has_madkudu',
    Component: withProps(() => ({ options: MadkuduScoreOptions }))(SelectsContainer),
    operators: [OperatorType.IS_ANY_OF],
    defaultValue: List.of('very good'),
    category: ConditionCategory.ENRICHMENT,
  },
  [ConditionType.OUTBOUND_SESSION]: {
    displayName: 'Outbound Session (from Drift email, Outreach, Salesloft)',
    Component: withProps(() => ({ options: BooleanOptions }))(SelectContainer),
    operators: [OperatorType.IS],
    defaultValue: true,
    getValueDisplay: value => (!!value ? 'true' : 'false'),
    category: ConditionCategory.DRIFT,
  },
  [ConditionType.OUTBOUND_REP]: {
    displayName: 'Outbound Rep',
    Component: RepSelectContainer,
    operators: [OperatorType.IS_ANY_OF],
    defaultValue: List.of(null),
    category: ConditionCategory.DRIFT,
  },
  [ConditionType.SEGMENT]: {
    displayName: 'Contact is in Segment',
    category: ConditionCategory.SEGMENT,
    operators: [OperatorType.IS_ANY_OF],
    defaultValue: List.of(null),
  },
  [ConditionType.TARGET_ACCOUNT]: {
    displayName: 'Targeted Account',
    Component: withProps(() => ({ options: BooleanOptions }))(SelectContainer),
    operators: [OperatorType.IS],
    defaultValue: true,
    getValueDisplay: value => (!!value ? 'true' : 'false'),
    category: ConditionCategory.DRIFT,
  },
  [ConditionType.EMAIL_PLAYBOOK]: {
    displayName: 'Clicked link in email playbook',
    requiredGate: 'has_marketing_sequences',
    category: ConditionCategory.EMAIL_PLAYBOOK,
    operators: [OperatorType.IS],
    defaultValue: null,
  },
})

export const ConditionTypesByCategory = ConditionTypes.groupBy(({ category }) => category)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/playbook/constants.js